import { Grid } from "@mui/material";

import styles from "./IndexesGosrCommentsModal.module.css";

export const IndexesGosrCommentsItem = ({ comment }) => {
	return (
		<Grid container item className={styles.itemContainer}>
			<Grid item xs={comment[1] ? 8 : 12} className={styles.itemContent}>
				{comment[0]}
			</Grid>
			{comment[1] && (
				<Grid item xs={4} className={styles.itemContent}>
					{comment[1]}
				</Grid>
			)}
		</Grid>
	);
};
